import React from 'react';
import { Icon, Spin } from 'antd';

type Props = {
    style?: Object;
};

export default function SmallSpinner({ style }: Props) {
    return (
        <Spin
            style={style}
            indicator={
                <Icon
                    data-cy="loader"
                    type="loading"
                    style={{ fontSize: 18 }}
                    spin
                />
            }
        />
    );
}
